import {
	login,
	getUserInfo,
	logout
} from '@/api/user'
import {
	setToken,
	getToken,
	removeToken
} from '@/utils/auth'

const state = {
	token: getToken() || '', // 从本地缓存取token
	userInfo: {}
}

const mutations = {
	SET_TOKEN: (state, token) => {
		state.token = token
		setToken(token) // 存储到localStorage
	},
	SET_USER_INFO: (state, userInfo) => {
		state.userInfo = userInfo
	},
	CLEAR_USER_INFO: (state) => {
		state.token = ''
		state.userInfo = {}
		removeToken() // 清除localStorage的token
	}
}

const actions = {
	// 登录操作（核心修改：取access_token）
	login({
		commit
	}, loginData) {
		return new Promise((resolve, reject) => {
			login(loginData).then(res => {
				// 重点：接口返回的token字段是access_token，所以取res.data.access_token
				const {
					access_token
				} = res.data
				commit('SET_TOKEN', access_token)
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	},

	// 获取用户信息
	getInfo({
		commit,
		state
	}) {
		return new Promise((resolve, reject) => {
			getUserInfo().then(res => {
				commit('SET_USER_INFO', res.data)
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	},

	// 退出登录
	logout({
		commit
	}) {
		return new Promise((resolve, reject) => {
			logout().then(res => {
				commit('CLEAR_USER_INFO')
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}